import React from 'react';
import imageConfetti from './confetti.svg';
import ProfileIcon from '../ProfileIcon/index';
import PropType from 'prop-types';
import { userShape } from '../../utils/shapes';
import './Ranking.css';

const MAX_PLAYER_NAME_LENGTH = 15;

function Ranking({ id, rank, player, score, type }) {
  if (rank === 1 || type === 'user') {
    return getPlacedRanking(id, rank, player, score, type);
  } else {
    return getRanking(id, rank, player, score);
  }
}

function getPlacedRanking(id, rank, player, score, type) {
  const displayName = player ? player.displayName : 'Unknown';
  return (
    <div key={id} className={`ranking placed ${type}`.trim()}>
      <div className="profile">
        <ProfileIcon
          size={40}
          src={player && player.avatarUrl}
          border="border"
        />
      </div>
      <div className="info">
        <div className="name">
          {type === 'user'
            ? 'YOUR SCORE'
            : displayName.substr(0, MAX_PLAYER_NAME_LENGTH)}
        </div>
        <div>{`${getNumberFormat(score)} points`}</div>
      </div>
      <div className="confetti">
        {rank === 1 ? <img src={imageConfetti} alt="Confetti" /> : null}
        <div className="position">
          <div className="yellow-circle">
            <div className="position-number">{rank}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

function getRanking(id, rank, player, score) {
  return (
    <div key={id} className="ranking row user-place">
      <div className="name">
        {player
          ? player.displayName.substr(0, MAX_PLAYER_NAME_LENGTH)
          : 'Unknown'}
      </div>
      <div className="points">{`${getNumberFormat(score)} points`}</div>
      <div className="position">{rank}</div>
    </div>
  );
}

function getNumberFormat(number) {
  return new Intl.NumberFormat().format(number);
}

Ranking.propTypes = {
  id: PropType.number.isRequired,
  rank: PropType.number.isRequired,
  player: userShape.isRequired,
  score: PropType.number.isRequired,
  type: PropType.string.isRequired
};

export default Ranking;



// WEBPACK FOOTER //
// ./src/components/Ranking/index.js